import { gql } from "@apollo/client";
const CREATE_FAVORITE = gql`
  mutation createFavorite($product_id: Float!) {
    createFavorite(product_id: $product_id) {
      __typename
      ... on Favorite {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const DELETE_FAVORITE = gql`
  mutation deleteFavorite($id: Float!) {
    deleteFavorite(id: $id) {
      __typename
      ... on Favorite {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { CREATE_FAVORITE, DELETE_FAVORITE };
